import { render, staticRenderFns } from "./TheContainer.vue?vue&type=template&id=31b982c2&"
import script from "./TheContainer.vue?vue&type=script&lang=js&"
export * from "./TheContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports